// extracted by mini-css-extract-plugin
export var burst = "PlateSlider-module--burst--3c832";
export var enter = "PlateSlider-module--enter--1d653";
export var enterFrom = "PlateSlider-module--enterFrom--eea6f";
export var enterTo = "PlateSlider-module--enterTo--397b2";
export var leaveFrom = "PlateSlider-module--leaveFrom--d7180";
export var leaveTo = "PlateSlider-module--leaveTo--fc523";
export var sunburstAnimate = "PlateSlider-module--sunburstAnimate--6f2cd";